var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.77,
    height: 17.84,
    viewBox: "0 0 14.77 17.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Bookmark_outline"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.77,
    height: 17.84
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bookmark_outline",
    "data-name": "Bookmark outline",
    clipPath: "url(#clip-Bookmark_outline)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22153",
    "data-name": "Group 22153",
    transform: "translate(0.202 0.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28751",
    "data-name": "Path 28751",
    d: "M6.87,13.846,1.981,16.524A.815.815,0,0,1,.894,16.2h0a.86.86,0,0,1-.1-.385V3.947C.8,1.683,2.343.778,4.569.778H9.8c2.158,0,3.773.845,3.773,3.018V15.815a.807.807,0,0,1-.807.807.89.89,0,0,1-.392-.1L7.451,13.846A.611.611,0,0,0,6.87,13.846Z",
    fill: "none",
    stroke: "#ececf1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    x2: 6.013,
    transform: "translate(4.154 6.173)",
    fill: "none",
    stroke: "#ececf1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkoutline);
export default __webpack_public_path__ + "static/media/Bookmark outline.4e03772372d5093bb2bd97b2f9677cff.svg";
export { ForwardRef as ReactComponent };